import uuid from 'uuid/v1';

export const templates = {
  id: uuid(),
  name: 'Templates',
  child: [
    {
      id: uuid(),
      type: 'plantilla',
      name: 'baseTemplate',
      template: {
        id: 'h3H9rvh0Ok',
        name: 'Raíz',
        width: 12,
        color: 'alca',
        height: 0,
        componente: 'Nada',
        arriba: 0,
        arribasize: '0vh',
        izquierda: 0,
        child: [
          {
            id: uuid(),
            name: 'Mapa',
            width: 12,
            height: '100vh',
            componente: 'Map',
            color: 'paper',
            arriba: 11,
            arribasize: '0vh',
            izquierda: 1
          },
          {
            id: uuid(),
            name: 'BotonEditor',
            width: 1,
            height: '6vh',
            componente: 'BotonEditor',
            color: 'elco',
            arriba: 12,
            arribasize: '60vh',
            izquierda: 11
          }
        ]
      }
    },
    {
      id: uuid(),
      type: 'plantilla',
      name: 'baseTemplate1',
      template: {
        id: 'h3H9rvh0Ok',
        name: 'Raíz',
        width: 12,
        color: 'alca',
        height: 0,
        componente: 'Nada',
        arriba: 0,
        arribasize: '0vh',
        izquierda: 0,
        child: [
          {
            id: uuid(),
            name: 'Mapa',
            width: 12,
            height: '100vh',
            componente: 'Map',
            color: 'paper',
            arriba: 11,
            arribasize: '0vh',
            izquierda: 1
          },
          {
            id: uuid(),
            name: 'NavBar',
            width: 2,
            height: '9vh',
            componente: 'NavBar',
            color: 'elco',
            arriba: 12,
            arribasize: '0vh',
            izquierda: 5
          },
          {
            id: uuid(),
            name: 'BotonEditor',
            width: 1,
            height: '6vh',
            componente: 'BotonEditor',
            color: 'elco',
            arriba: 12,
            arribasize: '60vh',
            izquierda: 11
          }
        ]
      }
    },
    {
      id: uuid(),
      type: 'plantilla',
      name: 'baseTemplate2',
      template: {
        id: 'h3H9rvh0Ok',
        name: 'Raíz',
        width: 12,
        color: 'alca',
        height: 0,
        componente: 'Nada',
        arriba: 0,
        arribasize: '0vh',
        izquierda: 0,
        child: [
          {
            id: uuid(),
            name: 'Mapa',
            width: 12,
            height: '100vh',
            componente: 'Map',
            color: 'paper',
            arriba: 11,
            arribasize: '0vh',
            izquierda: 1
          },
          {
            id: uuid(),
            name: 'BotonMenu',
            width: 1,
            height: '6vh',
            componente: 'BotonMenu',
            color: 'elco',
            arriba: 11,
            arribasize: '60vh',
            izquierda: 1
          },
          {
            id: uuid(),
            name: 'BotonEditor',
            width: 1,
            height: '6vh',
            componente: 'BotonEditor',
            color: 'elco',
            arriba: 12,
            arribasize: '60vh',
            izquierda: 11
          }
        ]
      }
    }
  ]
};

export const baseTemplate2 = {
  id: 'h3H9rvh0Ok',
  name: 'Raíz',
  width: 12,
  color: 'alca',
  height: 0,
  componente: 'Nada',
  arriba: 0,
  arribasize: '0vh',
  izquierda: 0,
  child: [
    {
      id: uuid(),
      name: 'Mapa',
      width: 12,
      height: '100vh',
      componente: 'Map',
      color: 'paper',
      arriba: 11,
      arribasize: '0vh',
      izquierda: 1
    },
    {
      id: uuid(),
      name: 'BotonMenu',
      width: 1,
      height: '6vh',
      componente: 'BotonMenu',
      color: 'elco',
      arriba: 11,
      arribasize: '60vh',
      izquierda: 1
    },
    {
      id: uuid(),
      name: 'BotonEditor',
      width: 1,
      height: '6vh',
      componente: 'BotonEditor',
      color: 'elco',
      arriba: 12,
      arribasize: '60vh',
      izquierda: 11
    }
  ]
};

export const mobileTemplate = {
  id: 'h3H9rvh0Ok',
  name: 'Raíz',
  width: 12,
  color: 'alca',
  height: 0,
  componente: 'Nada',
  arriba: 0,
  arribasize: '0vh',
  izquierda: 0,
  child: [
    {
      id: uuid(),
      name: 'Mapa',
      width: 12,
      height: '100vh',
      componente: 'Map',
      color: 'paper',
      arriba: 11,
      arribasize: '0vh',
      izquierda: 1
    },
    {
      id: uuid(),
      name: 'BotonMenu',
      width: 1,
      height: '6vh',
      componente: 'BotonMenu',
      color: 'elco',
      arriba: 11,
      arribasize: '60vh',
      izquierda: 1
    }
  ]
};
